/**
 * File Name          : sensor-battery.component.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Component, Input } from '@angular/core';
import { BLE_CHARGE_ICON } from '../../../../../projects/idl-physens/src/lib/models/battery_state_char.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sensor-battery',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sensor-battery.component.html',
  styleUrl: './sensor-battery.component.scss'
})
export class SensorBatteryComponent {
  CHARGE_STATES = BLE_CHARGE_ICON;

  @Input() batteryLevel!: BLE_CHARGE_ICON;
  @Input() color: string = '#FFFFFF';
  @Input() critColor: string = '#ff2424';


  is(...levels: BLE_CHARGE_ICON[]) {
    return levels.includes(this.batteryLevel);
  }
}
